import { render, staticRenderFns } from "./rate-widget.vue?vue&type=template&id=02bf17e4&scoped=true&"
import script from "./rate-widget.vue?vue&type=script&lang=js&"
export * from "./rate-widget.vue?vue&type=script&lang=js&"
import style0 from "./rate-widget.vue?vue&type=style&index=0&id=02bf17e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf17e4",
  null
  
)

export default component.exports